import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import VideoModule from './app';
import './styles.scss';
let VideoElements = {}
export default class VideoPlayer {
  constructor(config, $Videos, route) {
    $Videos.each((index, el)=>{
      let $el = $(el);
      let configId = $el.data('config-id');
      let playlistData = config.playlists.find( (playlist)=>{
        return playlist['config-id']==configId;
      });
      let videoId = playlistData==null || playlistData.videos.length==0 ? configId : playlistData.videos[0]["video-config-id"];
      let videoData = config.videos.find( (video) => {
        return video['config-id']==videoId;
      });
      if(!videoData) return;
      let props = {
        'index': index,
        'config-id': configId,
        'video': videoData,
        'playlist': playlistData,
        'videos': config.videos,
        'route': route
      }
      ReactDOM.render(React.createElement(VideoModule, props), el);
        $el.addClass('module-loaded');
    });
  }
}
VideoPlayer.selector = '[data-module="VideoPlayer"]';
VideoPlayer.init = (config, $Videos, route) => {
  $Videos = $Videos|| $(VideoPlayer.selector);
  if($Videos.length>0) {
    new VideoPlayer(config, $Videos, route);
  }
}
VideoPlayer.pause = (container=document)=>{
  let $container = $(container);
  $container.find('video').each( (index, videoEl)=> {
    videoEl.pause();
  });
}



// WEBPACK FOOTER //
// ./medscape_modules/video/index.js